export function throttle<T extends (...args: any[]) => void>(func: T, delay: number): T {
  let lastCall = 0;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  return function (this: any, ...args: Parameters<T>) {
    const now = Date.now();

    const invoke = () => {
      lastCall = now;
      timeoutId = null;
      func.apply(this, args);
    };

    if (now - lastCall >= delay) {
      invoke();
    } else if (!timeoutId) {
      timeoutId = setTimeout(invoke, delay - (now - lastCall));
    }
  } as T;
}
